import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Table } from 'primeng/table';
import { TranslateFormatText } from '../../helpers/array.helpers';
import { NotificationHelper } from '../../helpers/notification.helper';
import { MessageBoxButtons } from '../../models/enums/messageboxbuttons.enum';
import { MessageBoxIcon } from '../../models/enums/messageboxicon.enum';
import { MessageBoxResult } from '../../models/enums/messageboxresult.enum';
import { WorkflowService } from '../../services/workflow.service';
import { VersioningOverview } from '../../settings/versioningoverview/versioning.overview';
import { MessageBoxHelper } from '../dialogs/messagebox/messagebox.dialog';

interface Workflow {
    id: string;
    name: string;
}

@Component({
    selector: 'app-workflow-monitoring',
    templateUrl: './workflow-monitoring.page.html',
    styleUrls: ['./workflow-monitoring.page.css']
})
export class WorkflowMonitoringPage implements OnInit {
    @ViewChild('dt') dt: Table | undefined;

    workflows: Workflow[] = [];
    cols: any[] = [];
    searchTerm: string = '';

    constructor(
        private router: Router,
        private service: WorkflowService,
        private translateService: TranslateService
    ) { }

    ngOnInit(): void {
        this.cols = [
            { field: 'name', header: 'WorkflowMonitoringWorkflow' },
        ];

        this.loadWorkflows();
    }

    loadWorkflows(): void {
        this.service.GetAllServiceWorkflows().subscribe(x => {
            if (x) {
                this.workflows = x.map((wf: any) => ({
                    id: wf.Id,
                    name: wf.Name
                }));
            }
        });
    }

    createNewWorkflow(): void {
        this.router.navigate(['/settings/data/workflow/wf-service'], { queryParams: { addNew: true } });
    }

    viewWorkflow(workflow: Workflow): void {
        console.log('Viewing workflow:', workflow);
    }

    editWorkflow(workflow: Workflow): void {
        this.router.navigate(['/settings/data/workflow/wf-service'], { queryParams: { id: workflow.id } });
    }

    deleteWorkflow(workflow: Workflow): void {
        const tft = new TranslateFormatText('@@Sind Sie sicher, dass Sie den Workflow \'{0}\' loeschen moechten?');
        tft.FormatParams.push(workflow.name);
        MessageBoxHelper.ShowDialog(tft, new TranslateFormatText('@@Workflow loeschen'),
            MessageBoxButtons.YesNo, MessageBoxIcon.Question).then(x => {
                if (x == MessageBoxResult.Yes) {
                    this.deleteItemInternal(workflow, false);
                }
            });
    }

    private deleteItemInternal(sel: Workflow, ignoreVersions: boolean) {
        this.service.TryDeleteWorkflow(sel.id, true, ignoreVersions).subscribe(result => {
            if (result) {
                if (result.Deleted) {
                    this.loadWorkflows();
                    const success = new TranslateFormatText('@@Workflow \'{0}\' erfolgreich geloescht.');
                    success.FormatParams.push(sel.name);
                    NotificationHelper.Success(success, '@@Workflow loeschen');
                } else if (result.IsLocked) {
                    const text = new TranslateFormatText('@@LockedBy{0}');
                    text.FormatParams.push(result.LockedBy);
                    MessageBoxHelper.ShowDialog(text, new TranslateFormatText('@@LockedObject'),
                        MessageBoxButtons.Ok, MessageBoxIcon.Information);
                } else if (result.MultipleVersions) {
                    const text = new TranslateFormatText('@@MultipleVersionsInfoText');
                    text.FormatParams.push(result.LockedBy);
                    MessageBoxHelper.ShowDialog(text, new TranslateFormatText('@@MultipleVersionsInfoHeader'),
                        MessageBoxButtons.None, MessageBoxIcon.Information, 500, null, [
                        { Caption: '@@DeleteAllVersions', ID: 0 },
                        { Caption: '@@GoToVersionsOverview', ID: 1 },
                        { Caption: '@@Cancel', ID: 2 }
                    ]).then(result => {
                        if (result == 0) {
                            this.deleteItemInternal(sel, true);
                        } else if (result == 1) {
                            this.router.navigateByUrl(VersioningOverview.Path);
                        }
                    });
                }
            }
        });
    }
}